module.exports = __webpack_public_path__ + "mobile.336dd213.png";